import { Card, CardBody, Col, Row } from 'reactstrap'
import { ProgressBarsAnimated } from '../../../../Utils/Constants'
import { animatedData, animatedList } from '../../../../Data/Ui-Kits/Progress/Progress'
import { ProgressBar } from '../../../../AbstractElements'
import CardHeaderCommon from '../../../../Utils/CommonComponents/CardHeaderCommon'

const ProgressBarsAnimatedCart = () => {
  return (
    <Col xl="6">
      <Card>
        <CardHeaderCommon title={ProgressBarsAnimated} span={animatedData} />
        <CardBody className="progress-showcase">
          <Row>
            <Col>
              <ProgressBar color="primary" striped animated value="10" />
              {animatedList.map(({ color, value }, index) => (
                <ProgressBar color={color} striped animated value={value} key={index} />
              ))}
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  )
}

export default ProgressBarsAnimatedCart